import {appSessionStorage, appLocalStorage} from '../services';

/**
 * Local CheckoutCart replacement for @flashpointbv/solar-ui-checkout.
 *
 * The package cart store calls Magento REST via CheckoutGlobal/getApiPathWithQuoteMask,
 * which our Solar CheckoutGlobal does not provide — resulting in
 * GET /rest/V1/undefined/totals. Quote/totals traffic must go through Solar APIs.
 */
const initialState = () => {
  return {
    showCartPopup: false,
    showProductAdded: false,
    cartMessage: null,
    cartTotals: appSessionStorage.getItem('checkout-cart-totals', null),
    loadingCartTotals: false,
    headerTotals: appLocalStorage.getItem('checkout-cart-header-totals', null),
  };
};

const getters = {
  cartTotals: (state) => state.cartTotals,
  headerTotals: (state) => state.headerTotals,
  loadingCartTotals: (state) => state.loadingCartTotals,
  showCartPopup: (state) => state.showCartPopup,
  showProductAdded: (state) => state.showProductAdded,
  cartMessage: (state) => state.cartMessage,
};

const mutations = {
  SET_CART_TOTALS(state, data) {
    appSessionStorage.setItem('checkout-cart-totals', data);
    state.cartTotals = data;
  },
  SET_HEADER_TOTALS(state, data) {
    appLocalStorage.setItem('checkout-cart-header-totals', data);
    state.headerTotals = data;
  },
  SET_LOADING_TOTALS(state, data) {
    state.loadingCartTotals = data;
  },
  SHOW_CART_POPUP(state, payload) {
    state.showCartPopup = payload;
  },
  SHOW_PRODUCT_ADDED(state, payload) {
    state.showProductAdded = payload;
  },
  SET_CART_MESSAGE(state, message) {
    state.cartMessage = message;
  },
};

const actions = {
  async fetchCartTotals({commit, dispatch}) {
    commit('SET_LOADING_TOTALS', true);
    try {
      await dispatch('CheckoutTotals/fetchCartTotals', null, {root: true});
      // Mirror totals into header-cart local state for popup display.
      // CheckoutTotals owns the canonical store used by HeaderCart getters.
    } finally {
      commit('SET_LOADING_TOTALS', false);
    }
  },

  showCartPopup({commit, dispatch, rootState}, status) {
    commit('SHOW_CART_POPUP', status);
    if (status) {
      const totals = rootState.CheckoutTotals?.cartTotals || {};
      if (!Object.keys(totals).length) {
        dispatch('fetchCartTotals');
      }
    }
  },

  showProductAdded({commit}, payload) {
    commit('SHOW_PRODUCT_ADDED', payload);
    if (payload) {
      commit('SET_CART_MESSAGE', null);
    }
  },

  setCartMessage({commit}, message) {
    commit('SET_CART_MESSAGE', message);
    if (message) {
      commit('SHOW_PRODUCT_ADDED', false);
    }
  },
};

const CheckoutCart = {
  namespaced: true,
  state: initialState(),
  getters,
  actions,
  mutations,
};

export default CheckoutCart;
